<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-01-29 16:44:24
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="box">
      <ul>
        <li>
          <div style="display: flex">
            <label for>原密码</label>
            <el-input
              placeholder="请输入原密码"
              show-password
              v-model="password"
            ></el-input>
          </div>
        </li>
        <li>
          <div style="display: flex">
            <label for>新密码</label>
            <el-input
              show-password
              placeholder="请输入新密码"
              v-model="newPassword"
            ></el-input>
          </div>
        </li>
        <li>
          <div style="display: flex">
            <label for>确认新密码</label>
            <el-input
              show-password
              placeholder="请再次输入新密码"
              v-model="affirmPassword"
            ></el-input>
          </div>
        </li>
        <li>
          <div class="btn" @click="updetes">提 交</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Bus from "@/plugins/upload/bus";

import { update_password } from "@/api/file"; // 接口导入
import resetPwd from "@/mixins/resetPwd";
export default {
  components: {},
  computed: {},
  mixins:[resetPwd],
  data() {
    return {
      password: "",
      newPassword: "",
      affirmPassword: "",
    };
  },

  created() {},
  mounted() {
    localStorage.setItem("states", 2);
  },
  methods: {
    updetes() {
      //this.fromatPassword
      let data = {
        password: this.fromatPassword(this.password),
        newPassword: this.fromatPassword(this.newPassword),
        affirmPassword: this.fromatPassword(this.affirmPassword),
        userId:sessionStorage.getItem('userId')
      };
      update_password(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("修改成功,请重新登录");
          this.password == "";
          this.newPassword == "";
          this.affirmPassword == "";
          this.$router.replace({ name: "login" });
        } else {
          this.$message.info(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .box {
    height: 100%;
    margin: auto;

    ul {
      margin-top: 20vh;
      margin-left: 36%\9;
      -webkit-margin-left: 36%;
      li {
        display: flex;
        margin-top: 14px;
        .btn {
          // min-width: 300px;
          width: 327px;
          margin-left: 103px;
          background: #167afc;
          opacity: 0.5;
          border-radius: 4px;
          text-align: center;
          margin-top: 30px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 50px;
          cursor: pointer;
        }
        div {
          label {
            float: left;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #3c4353;
            width: 120px;
            margin-bottom: 8px;
          }
          /deep/ .el-input {
            min-width: 300px;
            margin-left: 10px;
            .el-input-group__append {
              background: #167afc;
              color: rgba(255, 255, 255, 1);
              cursor: pointer;
              opacity: 0.5;
            }
          }
          p {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #24558b;
            line-height: 34px;
          }
          .el-select {
            min-width: 522px;
          }
        }
        .right {
          margin-left: 60px;
        }
      }
      .buttonbox {
        margin-top: 239px;
        justify-content: center;
        .el-button:last-of-type {
          margin-left: 100px;
        }
      }
      .updata {
        justify-content: flex-end;
      }
    }
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      ul {
        margin-left: 36%;
      }
    }
  }
}
</style>


